import { GenderTypeOptions, HeightTypeOptions, Product } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { applicationFieldChanged } from 'common/actions/application'
import {
  lifeInsuranceApplicationGenderSelector,
  lifeInsuranceApplicationHeightInInchesSelector,
} from 'embed/selectors/application'
import { MultiProductDispatch } from 'embed/constants'
import { Fields } from 'embed/constants/fields'
import { MultiProductState } from 'embed/reducers'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

const styles = require('./styles.scss')

interface StoreProps {
  gender: GenderTypeOptions
  height: HeightTypeOptions
}

interface DispatchProps {
  dispatchHeightApplicationFieldChanged: (height: HeightTypeOptions) => void
}

type Props = StoreProps & DispatchProps & LifeInsuranceApplicationProps

export const UnconnectedApplicationStepHeight: React.SFC<Props> = (props) => {
  const { dispatchHeightApplicationFieldChanged, gender, height } = props

  React.useEffect(() => {
    props.setIsBeforeRouterQuestions(true)
  }, [])

  React.useEffect(() => {
    if (height === undefined) {
      switch (gender) {
        case GenderTypeOptions.FEMALE:
          dispatchHeightApplicationFieldChanged(HeightTypeOptions.FIVE_FOOT_FOUR)
          break
        case GenderTypeOptions.MALE:
          dispatchHeightApplicationFieldChanged(HeightTypeOptions.FIVE_FOOT_NINE)
          break
        default:
          dispatchHeightApplicationFieldChanged(HeightTypeOptions.FIVE_FOOT_SEVEN)
      }
    }
  }, [])

  return (
    <Wrapper {...props}>
      <StepTitle>How tall are you?</StepTitle>
      <ApplicationField product={Product.LifeInsurance} field={Fields.HeightInInches} styles={styles.formRow} />
    </Wrapper>
  )
}

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  height: lifeInsuranceApplicationHeightInInchesSelector(state),
  gender: lifeInsuranceApplicationGenderSelector(state),
})

const mapDispatchToProps = (dispatch: MultiProductDispatch): DispatchProps => ({
  dispatchHeightApplicationFieldChanged: (height: HeightTypeOptions) =>
    dispatch(applicationFieldChanged(Product.LifeInsurance, Fields.HeightInInches.key, height)),
})

export const ApplicationStepHeight = connect<StoreProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(UnconnectedApplicationStepHeight)
